import { required, size } from 'vee-validate/dist/rules'
import { extend, ValidationProvider, ValidationObserver, setInteractionMode } from "vee-validate"
setInteractionMode("eager")
extend("required", {
    ...required,
    message: "{_field_} no puede estar vacio",
})

const cards = {
    components: { ValidationObserver, ValidationProvider },
    data: () => ({
        loading: false,
        loadingTbl: false,
        loadingDel: {},
        loadingShow: {},
        dialog: false,
        valid: false,

        id: null, // Inicializa id en null
        description: '',
        titulo: '',
        useBullets: false,
        showCard: false,
        showImage: false,
        image: null,
        imageUrl: null,
        imagePosition: 'left',
        newBullet: '',
        bullets: [],
        bulletType: 'points', // Default to points
        backgroundColor: '',
        backgroundImage: null,
        fontSize: '', // Default font size 
        fontColor: '', // Default font color 

        colors: [
            { text: 'Predeterminado', value: '' },
            { text: 'Blanco', value: 'white' },
            { text: 'Rojo', value: 'red' },
            { text: 'Verde', value: 'green' },
            { text: 'Amarillo', value: 'yellow' },
            { text: 'Morado', value: 'purple' },
            { text: 'Gris', value: 'gray' },
            { text: 'Negro', value: 'black' }
        ], // Lista de colores disponibles 

        fontSizes: ['12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px'], // Lista de tamaños de fuente disponibles
        headers: [
            { text: "ID", value: "id", align: 'start', sortable: false },
            { text: "Titulo", value: "titulo", align: 'start', sortable: false },
            { text: "Mostrar tarjeta en inicio", value: "mostrar_tarjeta", align: 'start', sortable: false },
            { text: "Creado por", value: "creadorNombre", align: 'start', sortable: false },
            { text: "Fecha de creacion", value: "fecha_de_creacion", align: 'start', sortable: false },
            { text: "Acciónes", value: "action", align: 'start', sortable: false }
        ],
        items: []
    }),
    mounted() {
        this.fetchCards();
    },
    computed: {
        creatorId() {
            return this.$store.state.id;
        },
        cardStyle() {
            let style = {};
            if (this.backgroundColor) {
                style.backgroundColor = this.backgroundColor;
            }
            if (this.backgroundImage) {
                style.backgroundImage = `url(${URL.createObjectURL(this.backgroundImage)})`;
                style.backgroundSize = 'cover';
                style.backgroundPosition = 'center';
            }
            return style;
        },
        textStyle() {
            return {
                fontSize: this.fontSize,
                color: this.fontColor,
                lineHeight: '1.5'
            };
        },
        bulletValidation() {
            return this.useBullets && this.bullets.length === 0 ? 'required' : '';
        },
        imageValidation() {
            return this.id ? '' : 'required';
        }
    },
    watch: {
        showImage(newVal) {
            if (!newVal) {
                this.imageUrl = null;
            }
        },
        image(newVal) {
            if (this.showImage && newVal) {
                this.imageUrl = URL.createObjectURL(newVal);
            }
        }
    },
    methods: {
        resetForm() {
            this.titulo = '';
            this.description = '';
            this.useBullets = false;
            this.showImage = false;
            this.image = null;
            this.imageUrl = null;
            this.imagePosition = 'left';
            this.newBullet = '';
            this.bullets = [];
            this.bulletType = 'points';
            this.backgroundColor = '';
            this.backgroundImage = null;
            this.fontSize = '';
            this.fontColor = '';
            this.id = null;
        },
        cancelForm() {
            this.$refs.datos.reset();
            this.resetForm();
            this.dialog = false;
        },
        addBullet() {
            if (this.newBullet.trim()) {
                this.bullets.push(this.newBullet);
                this.newBullet = '';
            }
        },
        removeBullet(index) {
            this.bullets.splice(index, 1);
        },
        async fetchCards() {
            this.loadingTbl = true;
            try {
                let response = await this.$axios.get('getCards');
                this.items = response.data.cards;
            } catch (error) {
                console.log('Error al obtener las tarjetas:', error);
            } finally {
                this.loadingTbl = false;
            }
        },
        async submitForm(reset) {
            this.loading = true;
            const validTypes = ['image/jpeg', 'image/png', 'image/gif']; // Validación de imagen principal 
            // Restablecer errores previos 
            this.$refs.datos.setErrors({});
            if (!this.id && this.showImage) {
                if (!this.image) {
                    this.$refs.datos.setErrors({ Imagen: ['Debe seleccionar una imagen'] });
                    this.loading = false;
                    return;
                }
                if (!validTypes.includes(this.image.type)) {
                    this.$refs.datos.setErrors({ Imagen: ['El archivo debe ser una imagen (jpeg, png, gif)'] });
                    this.loading = false; return;
                }
            } // Validación de imagen de fondo 
            if (this.backgroundImage && !validTypes.includes(this.backgroundImage.type)) {
                this.$refs.datos.setErrors({ 'Imagen de Fondo': ['El archivo debe ser una imagen (jpeg, png, gif)'] });
                this.loading = false;
                return;
            }
            // Validación de viñetas 
            if (this.useBullets && this.bullets.length === 0) {
                this.$refs.datos.setErrors({
                    Viñetas: ['Debe agregar al menos una viñeta']
                });
                this.loading = false;
                return;
            }
            // Aquí puedes manejar el envío del formulario, por ejemplo, guardar los datos en una base de datos
            const formData = new FormData();
            formData.append('titulo', this.titulo);
            formData.append('description', this.description);
            formData.append('useBullets', this.useBullets);
            formData.append('bullets', this.bullets.join(',')); // Convertir el array a una cadena separada por comas
            formData.append('bulletType', this.bulletType);
            formData.append('showCard', this.showCard);
            formData.append('showImage', this.showImage);
            formData.append('imagePosition', this.imagePosition);
            formData.append('backgroundColor', this.backgroundColor);
            formData.append('fontSize', this.fontSize);
            formData.append('fontColor', this.fontColor);
            formData.append('creatorId', this.creatorId); // Agregar el creatorId desde Vuex
            if (this.image) {
                formData.append('image', this.image);
            }
            if (this.backgroundImage) {
                formData.append('backgroundImage', this.backgroundImage);
            }
            try {
                let response;
                if (this.id) {
                    formData.append('id', this.id);
                    response = await this.$axios.post('updateCard', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                    this.$toast.success('Tarjeta actualizada con éxito');
                } else {
                    // Si no hay id, crea una nueva tarjeta
                    response = await this.$axios.post('newCard', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                    this.$toast.success('Tarjeta agregada con éxito');
                }
                this.$refs.datos.reset();
                reset();
                this.resetForm();
                this.dialog = false;
                this.fetchCards();
            } catch (error) {
                console.error('Error al guardar los eventos:', error);
                this.$toast.error('Hubo un error al enviar los datos de la tarjeta');
            } finally {
                this.loading = false;
            }

        },
        async deleteCard(cardId) {
            this.$set(this.loadingDel, cardId, true); // Activa el estado de carga solo para la imagen específica
            try {
                const response = await this.$axios.delete('deleteCards', { data: { card: cardId } });
                this.items = this.items.filter(f => f.id !== cardId);
                this.$toast.success('Tarjeta eliminada con éxito');
            } catch (error) {
                //console.error('Error al eliminar la tarjeta:', error);
                this.$toast.error('Hubo un error al elimninar la tarjeta');
            } finally {
                this.$set(this.loadingDel, cardId, false); // Desactiva el estado de carga después de eliminar la imagen
            }
        },
        async showCards(cardId) {
            this.$set(this.loadingShow, cardId, true); // Inicia el indicador de carga
            try {
                const response = await this.$axios.post('showCards', { card: cardId });
                const newValue = response.data.new_value;
                this.items = this.items.map(item => {
                    if (item.id === cardId) {
                        item.mostrar_tarjeta = newValue;
                    }
                    return item;
                });
                this.$toast.success('Las cambios en la Tarjeta se realizaron con éxito');
                //this.fetchFiles();
            } catch (error) {
                console.error('Error al actualizar el estado de mostrar_imagen:', error);
                this.$toast.error('Hubo un error al hacer cambios en la tarjeta');
            } finally {
                this.$set(this.loadingShow, cardId, false); // Detiene el indicador de carga
            }
        },
        editCard(item) {
            this.id = item.id;
            this.titulo = item.titulo;
            this.description = item.descripcion;
            this.useBullets = item.usar_viñetas;
            this.bullets = item.viñetas.replace(/[{}]/g, '').split(',');
            this.bulletType = item.tipo_viñeta;
            this.showCard = item.mostrar_tarjeta;
            this.showImage = item.mostrar_imagen;
            this.imageUrl = item.image_url;
            this.imagePosition = item.image_posicion;
            this.backgroundColor = item.background_color;
            this.backgroundImageUrl = item.background_image_url;
            this.fontSize = item.font_size;
            this.fontColor = item.font_color;
            this.dialog = true; // Abre el diálogo
        }
    }
}
export default cards